import {Injectable, Injector, inject} from '@angular/core';
import {Observable, Observer, Subject, catchError, map, tap, throwError} from 'rxjs';
import {AbstractTableToolsPsFormarService, IPsResponseFormat} from './abstract-table-tools-psformart.service';
import {CustomerService} from './customer.service';
import { TiposEmpresa } from './tipos-empresa';
export interface IAlumnisRecord {
    id_alumnis: number;
	nombre: string;
	apellido1: string;
	apellido2: string;
    dni: string;
	email: string;
	telefono: string;
	cargo: string;
	ano_master: string;
	tipo_empresa: string;
	empresa: string;
    nif_empresa: string;
	direccion: string;
    codigo_postal: string;
	ciudad: string;
	pais: string;
    especializacion: string;
    apellidos: string;
    fecha_alta: Date;
    num_colegiado: string;
    fecha_registro: Date|null;

    [key: string]: any;
};
export type { IPsResponseFormat };

@Injectable({
    providedIn: 'root'
})
export class AlumnisService extends AbstractTableToolsPsFormarService {
    protected _TiposEmpresaS: TiposEmpresa = inject(TiposEmpresa);
    protected _class_name = 'Alumnis';
    protected _inc_json = 'alumnis';
    private _endpoints = {
        update: 'grabarFichaAsJSON',
        delete: 'borrarFichaFiltro',
        read: 'getAlumnisRegistrados',
        readRegistrados: 'getAlumnisRegistrados',
        readFilter: 'getFilasTabla',
        checkAlumni: 'checkAlumni',
        load: 'cargarAlumnis',
    };
    private _Alumnis_list: IAlumnisRecord[] = [];

    // sended when filter change
    private _filterChangeSubject = new Subject<IAlumnisRecord[]>();
    public onFilterChange = this._filterChangeSubject.asObservable();

    // sended when data has change (crate, update or delete)
    private _contentChangeSubject = new Subject<IAlumnisRecord[]>();
    public onContentChange = this._contentChangeSubject.asObservable();

    public last_label = '';
    
    
    public forbidden_columns = ['pais'];

    // ===========================================================================
    // ---------------------------------------------------------------------------
    constructor(
        protected InjectorL: Injector,
        private _CustomerS: CustomerService
    ) {
        super(InjectorL);
        this.value = this._getNewEmptyRecord();
    }

    get value_list(): IAlumnisRecord[] {

        return this._Alumnis_list;

    }
    set value_list(list: IAlumnisRecord[]) {
        this._Alumnis_list = list;
    }
    
    get inc_json(): string {
        return this._inc_json;
    }

    // ===========================================================================
    // ---------------------------------------------------------------------------
    public readAlumnis(): Observable<IAlumnisRecord[]> {
        const callparams = {}
        return new Observable((obs: Observer<IAlumnisRecord[]>) => {
            this.requestToServerPostJSON(this._endpoints.readRegistrados, callparams).subscribe(
                (readed_info: IPsResponseFormat) => {
                    if (readed_info.error.codigo !== '' ) {
                        obs.error(readed_info.error.codigo + ': '+ readed_info.error.texto);
                    } else {
                        
                        this._Alumnis_list = this._converReadData(readed_info.datos);
                        this._contentChangeSubject.next(this._Alumnis_list);
                        obs.next(this._Alumnis_list);                        
                    }
                },
                (e:any) => {
                    // console.error(e.message);
                    obs.error(e);
                }
            );
        });

    }

    // ---------------------------------------------------------------------------
    public readFilter(filter_in: object): Observable<IAlumnisRecord[]> {
        /*
         * Llamado por la validación de únicos
         *     No se guardan los datos aquí leidos porque solo
         *   sirven para comprobar si es un indice único
         */
        const callparams = {
            filter: filter_in
        };
        return this.requestToServerPostJSON(this._endpoints.readFilter, callparams).pipe(
            map((readed_info: IPsResponseFormat) => {
                if (readed_info.error.codigo !== '' ) {
                    // obs.error(readed_info.error.codigo + ': '+ readed_info.error.texto);
                    throw new Error(readed_info.error.codigo + ': '+ readed_info.error.texto);
                } else {
                    // obs.next(readed_info.datos);
                    // this._Alumnis_list = this._converReadData(readed_info.datos);
                    // this._contentChangeSubject.next(this._Alumnis_list);
                    return this._converReadData(readed_info.datos);
                }
            }),
        );

    }
    
// ---------------------------------------------------------------------------
    public checkAlumni(filter_in: object): Observable<IAlumnisRecord[]> {
        const callparams = {
            filter: filter_in
        };
        return this.requestToServerPostJSON(this._endpoints.checkAlumni, callparams).pipe(
            map((readed_info: IPsResponseFormat) => {
                if (readed_info.error.codigo !== '' && readed_info.error.codigo != '0' ) {
                    // obs.error(readed_info.error.codigo + ': '+ readed_info.error.texto);
                    // throw new Error(readed_info.error.codigo + ': '+ readed_info.error.texto);
                    const error = new Error(<string>readed_info.error.texto);
                    Object.assign(error, { code: readed_info.error.codigo });
                    throw error;
                } else {
                    // obs.next(readed_info.datos);
                    this._Alumnis_list = this._converReadData(readed_info.datos);
                    this._contentChangeSubject.next(this._Alumnis_list);
                    return this._Alumnis_list;
                }
            }),
        );

    }
        
    // ===========================================================================
    // ---------------------------------------------------------------------------
    public save(alumni_record: IAlumnisRecord): Observable<IAlumnisRecord> {

        return this.requestToServerPostJSON(this._endpoints.update, alumni_record).pipe(
            tap((r: IAlumnisRecord) => {
                console.log('Alumni guardada');
                this._contentChangeSubject.next([r]);
            }),
            catchError((e: string) => {
                console.error('AlumniService::save Error guardando alumni: ' + e);
                return throwError(() => e);
            })
        );

    }

    // ---------------------------------------------------------------------------
    public delete(alumni_record: IAlumnisRecord): Observable<IAlumnisRecord> {

        const del_filter = 'id_alumnis = ' + alumni_record.id_alumnis;
        return this.requestToServerPostJSON(this._endpoints.delete, del_filter).pipe(
            tap((r: IAlumnisRecord) => {
                console.log('Alumni borrado');
                // Ejecutamos el efecto secundario en el Subject
                this._contentChangeSubject.next([r]);
            }),
            catchError((e: string) => {
                console.error('AlumniService::delete Error eliminando Alumni: ' + e);
                // Re-lanzamos el error para que el componente que se suscriba pueda manejarlo
                return throwError(() => e);
            })
        );

    }

    // ===========================================================================
    // ---------------------------------------------------------------------------
    protected _getNewEmptyRecord(): IAlumnisRecord {
        return {
            id_alumnis: 0,
            nombre: '',
            apellido1: '',
            apellido2: '',
            dni: '',
            email: '',
            telefono: '',
            cargo: '',
            ano_master: new Date().getFullYear().toString(),
            tipo_empresa: this._TiposEmpresaS.default_value,   // 'Correduría',
            empresa: '',
            nif_empresa: '',
            direccion: '',
            codigo_postal: '',
            ciudad: '',
            pais: '',
            especializacion: '',
            fecha_alta: new Date(),
            apellidos: '',
            num_colegiado: '',
            fecha_registro: new Date(),
        }
    }
    
    // ---------------------------------------------------------------------------
    private _converReadData(readed_data: any[]): IAlumnisRecord[] {
        const converted_data = [];
        
        for (let row of readed_data) {
            const converted_row: any = {};
            let ind = 0;

            for (const field in this.empty_record) {
                converted_row[field] = row[ind++];
            }
            converted_data.push(converted_row);
        
        }
        
        return converted_data;
    }

}
